module.exports = __webpack_public_path__ + "media/img/logos/deloitte-6c8c0827f3dd4ac565b25a9fa945908e.svg";